<!-- 百日誓师-工作台 -->
<template>
  <div class="container">
    <div class="content">
      <!-- 第一部分：生成H5链接 -->
      <a-row :gutter="24" style="margin-top: 15px">
        <a-col :span="24" class="title-1 title-margin flex-between">
          <div>生成H5链接：</div>
        </a-col>
      </a-row>
      <a-card :bordered="true">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="学校">
                  <a-select
                    v-model="generateUrlParam.tenantId"
                    :allowClear="true"
                    v-decorator="[
                      'generateUrlParam.tenantId',
                      { rules: [{ required: true, message: '请选择学校' }] },
                    ]"
                    placeholder="请选择学校"
                    @change="handleTenantChange"
                  >
                    <a-select-option v-for="item in tenantList" :key="item.id" :value="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="班级">
                  <a-select
                    v-model="generateUrlParam.classId"
                    :allowClear="true"
                    v-decorator="[
                      'generateUrlParam.classId',
                      { rules: [{ required: true, message: '请选择班级' }] },
                    ]"
                    placeholder="请选择班级"
                  >
                    <a-select-option v-for="item in classList" :key="item.id" :value="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="12" :lg="12" :md="12" :sm="24">
                <a-form-item label="生产域名">
                  <a-input
                    placeholder="请输入生产域名"
                    v-model="generateUrlParam.domain"
                    disabled
                  ></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="copyUrl" icon="copy" style="margin-left: 8px">
                    生成并复制
                  </a-button>
                  <a-button
                    type="primary"
                    @click="copyReset"
                    icon="reload"
                    style="margin-left: 8px"
                  >
                    重置
                  </a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
      </a-card>

      <!-- 第二部分：班级订单查询 -->
      <a-row :gutter="24" style="margin-top: 25px">
        <a-col :span="24" class="title-1 title-margin flex-between">
          <div>班级订单查询：</div>
        </a-col>
      </a-row>
      <a-card :bordered="true">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="学校">
                  <a-select
                    v-model="queryParam.tenantId"
                    v-decorator="[
                      'queryParam.tenantId',
                      { rules: [{ required: true, message: '请选择学校' }] },
                    ]"
                    placeholder="请选择学校"
                    @change="handleTenantChange"
                  >
                    <a-select-option v-for="item in tenantList" :key="item.id" :value="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="班级">
                  <a-select
                    v-model="queryParam.classId"
                    v-decorator="[
                      'queryParam.classId',
                      { rules: [{ required: true, message: '请选择班级' }] },
                    ]"
                    placeholder="请选择班级"
                  >
                    <a-select-option v-for="item in classList" :key="item.id" :value="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="订单状态">
                  <a-select
                    v-model="queryParam.status"
                    v-decorator="[
                      'queryParam.status',
                      { rules: [{ required: true, message: '请选择订单状态' }] },
                    ]"
                    placeholder="请选择订单状态"
                  >
                    <a-select-option v-for="item in statusList" :key="item.id" :value="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24" v-if="false">
                <a-form-item label="学校">
                  <a-input placeholder="请输入学校" v-model="queryParam.tenantId"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24" v-if="false">
                <a-form-item label="班级">
                  <a-input placeholder="请选择班级" v-model="queryParam.classId"></a-input>
                </a-form-item>
              </a-col> -->
              <template v-if="toggleSearchStatus">
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="手机号">
                    <a-input placeholder="请输入手机号" v-model="queryParam.phone"></a-input>
                  </a-form-item>
                </a-col>
                <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="商品金额">
                    <a-input placeholder="请输入商品金额" v-model="queryParam.amount"></a-input>
                  </a-form-item>
                </a-col> -->
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="商品名称">
                    <a-input placeholder="请输入商品名称" v-model="queryParam.name"></a-input>
                  </a-form-item>
                </a-col>
              </template>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button
                    type="primary"
                    @click="searchReset"
                    icon="reload"
                    style="margin-left: 8px"
                  >
                    重置
                  </a-button>
                  <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- table区域-begin -->
        <div>
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange"
          ></a-table>
        </div>
        <!-- table区域-end -->
      </a-card>
    </div>
  </div>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction } from '@/api/manage'
import { copyText } from '@/utils/util'
export default {
  name: 'ActivityDayOathPane',
  mixins: [JeecgListMixin],
  data() {
    return {
      generateUrlParam: {
        tenantId: undefined,
        classId: undefined,
        domain: 'https://axxdd.hzqmfz.com/aigoes-payment-h5',
      }, // 生成H5链接参数
      tenantList: [], // 学校列表
      classList: [], // 班级列表
      statusList: [
        { id: 1, name: '已下单未付款' },
        { id: 2, name: '已付款' },
        { id: 3, name: '订单作废' },
      ], // 订单状态列表
      // 表头
      columns: [
        {
          title: '#序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return (this.ipagination.current - 1) * this.ipagination.pageSize + parseInt(index) + 1
          }.bind(this),
        },
        {
          title: '学校id',
          align: 'center',
          dataIndex: 'tenantId',
        },
        {
          title: '班级',
          align: 'center',
          dataIndex: 'className',
        },
        {
          title: '学生',
          align: 'center',
          dataIndex: 'studentName',
        },
        {
          title: '手机号',
          align: 'center',
          dataIndex: 'phone',
          customRender: (text) => {
            // 手机号脱敏
            return text ? text.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') : '-'
          },
        },
        {
          title: '商品名称',
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: '商品金额',
          align: 'center',
          dataIndex: 'amount',
        },
        {
          title: '下单时间',
          align: 'center',
          dataIndex: 'orderTime',
          customRender: (text) => {
            return text ? text : '-'
          },
        },
        {
          title: '付款时间',
          align: 'center',
          dataIndex: 'paymentTime',
          customRender: (text) => {
            return text ? text : '-'
          },
        },
        {
          title: '支付方式', // (1-微信支付 2-支付宝支付)
          align: 'center',
          dataIndex: 'paymentType',
          customRender: (text) => {
            const paymentTypeMap = {
              1: '微信',
              2: '支付宝',
            }
            return paymentTypeMap[text] || text
          },
        },
        {
          title: '订单状态', // (1-已下单 2-已付款 3-订单作废)
          align: 'center',
          dataIndex: 'status',
          customRender: (text) => {
            const statusMap = {
              1: '下单未付款',
              2: '下单已付款',
              3: '订单作废',
            }
            return statusMap[text] || text
          },
        },
      ],
      url: {
        list: '/schoolOrder/listByDayOath', // 百日誓师订单列表, 2025-03-31，建武新增
        delete: '/schoolOrder/delete',
        deleteBatch: '/schoolOrder/deleteBatch',
        exportXlsUrl: '/schoolOrder/exportXls',
        importExcelUrl: '/schoolOrder/importExcel',
      },
    }
  },
  created() {
    this.loadTenantList() // 获取学校列表
  },
  methods: {
    loadTenantList() {
      // 获取学校列表， 老订单接口，非新增
      getAction('/sys/tenant/list', {
        pageNo: 1,
        pageSize: 1000, //TODO 暂时放大单页查询量1000
        order: 'desc',
      }).then((res) => {
        console.log(res)
        if (res.success) {
          this.tenantList = res.result?.records
        }
      })
    },
    handleTenantChange(value) {
      // 获取班级列表， 2025-03-31，建武新增
      getAction('/aigoes/schoolClass/listByTenanId', {
        tenantId: value,
      }).then((res) => {
        console.log(res)
        if (res.success) {
          this.classList = res.result
        }
      })
    },
    copyReset() {
      this.generateUrlParam = {
        tenantId: '',
        classId: '',
      }
    },
    copyUrl() {
      if (!this.generateUrlParam.tenantId) {
        this.$message.error('请选择学校')
        return
      }
      // 复制学校网址
      const URL = `${this.generateUrlParam.domain}/pages/dayoath/index?tenantId=${this.generateUrlParam.tenantId}&classId=${this.generateUrlParam.classId}`
      console.log('H5入口地址: ', URL)
      copyText(
        URL,
        () => {
          this.$message.success(`H5入口地址: ${URL}`)
          this.$message.success('链接已复制到剪贴板')
        },
        (err) => {
          this.$message.error('复制失败，请手动复制')
          console.error('复制失败:', err)
        }
      )
    },
  },
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}
</style>

